module.exports = __webpack_public_path__ + "static/media/des1.98b07879.jpg";